<template>
  <KioskTable/>
</template>

<script>

import KioskTable from '@/components/KioskTable'

export default {
  name: 'Home',
  components: {KioskTable
  }
}
</script>
